import { apiService, BookingRequest, BookingResponse } from './apiService';

export interface BookingData {
  id: string;
  name: string;
  email: string;
  phone: string;
  eventType: string;
  package: string;
  date: string;
  time: string;
  location: string;
  details: string;
  createdAt: string;
  status: 'pending_approval' | 'approved' | 'confirmed' | 'rejected' | 'cancelled';
  approvedAt?: string;
  approvedBy?: string;
  rejectionReason?: string;
}

export const saveBooking = async (bookingData: Omit<BookingData, 'id' | 'createdAt' | 'status'>): Promise<string> => {
  try {
    const response = await apiService.createBooking(bookingData as BookingRequest);
    
    if (response.success && response.data) {
      return response.data.id;
    } else {
      throw new Error(response.error || 'Failed to save booking');
    }
  } catch (error) {
    console.error('Error saving booking:', error);
    throw new Error('Failed to save booking to server');
  }
};

export const getBooking = async (bookingId: string): Promise<BookingData | null> => {
  try {
    const response = await apiService.getBooking(bookingId);
    
    if (response.success && response.data) {
      return response.data as BookingData;
    }
    return null;
  } catch (error) {
    console.error('Error loading booking:', error);
    return null;
  }
};

export const getAllBookings = async (): Promise<BookingData[]> => {
  try {
    const response = await apiService.getAllBookings();
    
    if (response.success && response.data) {
      return response.data as BookingData[];
    }
    return [];
  } catch (error) {
    console.error('Error loading bookings:', error);
    return [];
  }
};

export const updateBookingStatus = async (bookingId: string, status: BookingData['status']): Promise<boolean> => {
  try {
    const response = await apiService.updateBookingStatus(bookingId, status);
    return response.success;
  } catch (error) {
    console.error('Error updating booking status:', error);
    return false;
  }
};
